import React from 'react';
import './Icon.css';
import './Element.css';
import config from '../../config.json';



import PropTypes from 'prop-types';


const Icon = (props) => {
    const { id, src, height, coordinates, visible, enabled, flashing, onClick, zIndex } = props;
    const iconId = `icon-${id}`;

    // Standard-størrelsen på ikoner 5vh i højde og bredde:
    const heightToWidthRatio = 9/16;
    const standardHeight = 5;

    const iconHeight = height || standardHeight;
    const width = iconHeight * heightToWidthRatio;

    // hvis koord er 0 begge to, så skal ikonet stå i midten
    const iconCoordinates = {
        x: coordinates.x || 50 - (width/2) + 3.25,
        y: coordinates.y || 50 - (iconHeight/2) - 6.8,
    };

    const iconStyling = {
        left: iconCoordinates.x + 'vw',
        top: iconCoordinates.y + 'vh',
        width: width + 'vw',
        height: iconHeight + 'vh'
    }

    iconStyling.zIndex = zIndex || 20;

    const cls = flashing ? 'blink' : '';

    // TODO tilføj evt. highlight klasse til icon-div
    if (visible || flashing) {
        return (
            <div id={iconId} className={'icon-wrapper ' + cls} style={iconStyling} onClick={onClick}>
                <img src={`${config.server}${src}`} className="icon-image" alt="" />
            </div>
        );
    }
    return null;
}


Icon.propTypes = {
    id: PropTypes.number,
    src: PropTypes.string,
    height: PropTypes.number,
    coordinates: PropTypes.shape({
        x: PropTypes.number,
        y: PropTypes.number
    }),
    visible: PropTypes.bool,
    enabled: PropTypes.bool,
    flashing: PropTypes.bool,
    onClick: PropTypes.func
}
export default Icon;